import React, { useState, useEffect, useRef } from 'react';

const DEFAULT_ITEMS = [
  "🌟 Summer Health Checkup Package - 30% Off! Book now!",
  "🆓 Free Doctor Consultation on First Visit - Limited time offer",
  "🏢 Corporate Health Packages - Special rates for companies",
  "🩺 Advanced Radiology Tests - 15% Discount this month"
];

const NewsTicker = () => {
  const [newsItems, setNewsItems] = useState(DEFAULT_ITEMS);
  const [isLoading, setIsLoading] = useState(true);
  const tickerRef = useRef(null);
  const [tickerItems, setTickerItems] = useState([]);
  const [animationPlayState, setAnimationPlayState] = useState('running');

  useEffect(() => {
    const fetchNewsTicker = async () => {
      try {
        const response = await fetch(`${import.meta.env.VITE_API_URL}/layout/news-ticker/`);
        if (response.ok) {
          const data = await response.json();
          setNewsItems(data.items || DEFAULT_ITEMS);
        }
      } catch (error) {
        console.error('Error fetching news ticker:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchNewsTicker();
  }, []);

  useEffect(() => {
    // Duplicate items for seamless loop
    if (newsItems.length > 0) {
      setTickerItems([...newsItems, ...newsItems]);
    }
  }, [newsItems]);

  const getAnimationDuration = () => {
    if (newsItems.length === 0) return 30;
    const baseDuration = 50; // seconds
    const averageItemLength = newsItems.reduce((acc, item) => acc + item.length, 0) / newsItems.length;
    return baseDuration * (averageItemLength / 50);
  };

  if (isLoading) {
    return (
      <div className="w-full bg-black text-white py-3">
        <div className="container mx-auto flex items-center">
          <div className="bg-red-600 px-3 py-1 rounded mr-4">
            <span className="font-bold text-sm uppercase tracking-wider">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div 
      className="w-full bg-black text-white py-3 overflow-hidden"
      onMouseEnter={() => setAnimationPlayState('paused')}
      onMouseLeave={() => setAnimationPlayState('running')}
    >
      <div className="container mx-auto flex items-center">
        {/* Breaking News label */}
        <div className="flex-shrink-0 bg-red-600 px-3 py-1 rounded mr-4 flex items-center">
          <span className="font-bold text-sm uppercase tracking-wider">Latest Offers</span>
        </div>
        
        {/* Ticker container */}
        <div className="flex-1 overflow-hidden">
          <div 
            ref={tickerRef}
            className="whitespace-nowrap"
            style={{
              display: 'inline-block',
              animation: `scroll ${getAnimationDuration()}s linear infinite`,
              animationPlayState: animationPlayState
            }}
          >
            {tickerItems.map((item, index) => (
              <span key={index} className="inline-block mx-8 text-sm md:text-base">
                {item} 
                <span className="inline-block w-3 h-3 rounded-full bg-yellow-400 ml-4"></span>
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* CSS for animation */}
      <style jsx>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
      `}</style>
    </div>
  );
};

export default NewsTicker;